import { CalendarFileContent } from '../../api/bookingApi.types';

/** Safari and some Firefox versions cancel the download if the URL is revoked at once. */
const REVOKE_DELAY_MILLISECONDS = 10_000;

/**
 * Hands the calendar file to the browser as a download. The file never
 * touches storage and its object URL is released a few seconds after the click.
 */
export const saveCalendarFile = (file: CalendarFileContent): void => {
  const url = URL.createObjectURL(
    new Blob([file.content], { type: file.contentType })
  );
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = file.filename;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  setTimeout(() => URL.revokeObjectURL(url), REVOKE_DELAY_MILLISECONDS);
};
